<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";
import Stat from "@/components/widgets/stat";

// Rótulos amigáveis para status retornados pela API
const statusLabels = {
  await_plan: "Aguardando definição do plano",
  plan_chosen: "Plano escolhido — aguardando pagamento",
  confirm_buy: "Aguardando confirmação da assinatura",
  await_payment: "Aguardando pagamento",
  payment_processing: "Pagamento em processamento",
  payment_pending: "Pagamento pendente",
  payment_success: "Pagamento confirmado",
  active: "Ativo",
  overdue: "Em atraso",
  suspended: "Suspenso",
  canceled_client: "Cancelado",
  canceled_overdue: "Cancelado por falta de pagamento",
  inactive: "Inativo",
};

export default {
  locales: {
    pt: {},
    es: {},
  },
  components: {
    Layout,
    Stat,
  },
  computed: {
    statusHint() {
      if (!this.client) {
        return null;
      }
      const critical = [
        "overdue",
        "payment_pending",
        "suspended",
        "canceled_client",
        "canceled_overdue",
      ];
      if (!critical.includes(this.client.status)) {
        return null;
      }
      return "Para faturas e informações de cobrança, utilize o menu Pagamentos neste painel.";
    },
  },
  data() {
    return {
      loading: true,
      errorMessage: null,
      statData: null,
      client: null,
      plan: null,
    };
  },
  methods: {
    statusLabel(code) {
      if (!code) {
        return "—";
      }
      return statusLabels[code] || code;
    },
    buildStatData() {
      const planName = this.plan && this.plan.name ? this.plan.name : "—";
      const due =
        this.client && this.client.date_due ? this.client.date_due : "—";
      let value = "—";
      if (this.plan && this.plan.value !== undefined && this.plan.value !== null) {
        value = this.$options.filters.currency(this.plan.value);
      }
      this.statData = [
        { title: "Plano atual", value: planName },
        { title: "Situação", value: this.statusLabel(this.client.status) },
        { title: "Vencimento", value: due },
        { title: "Valor", value },
      ];
    },
    getCurrent() {
      this.loading = true;
      this.errorMessage = null;
      this.statData = null;
      this.client = null;
      this.plan = null;

      api
        .get("plans/current")
        .then((response) => {
          if (response.data.status === "success") {
            this.client = response.data.client;
            this.plan = response.data.current;
            this.buildStatData();
          } else {
            this.errorMessage =
              (response.data && response.data.message) ||
              "Não foi possível carregar os dados do plano.";
          }
        })
        .catch(() => {
          this.errorMessage =
            "Não foi possível carregar os dados do plano. Tente novamente.";
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.getCurrent();
  },
};
</script>

<template>
  <Layout>
    <div class="page-title-box d-md-flex justify-content-between mb-3">
      <div>
        <h3>Meu Plano</h3>
        <p>Situação e dados do seu plano contratado.</p>
      </div>
    </div>

    <div v-if="loading" class="text-center">
      <b-spinner class="ml-2 align-middle" variant="default" role="status"></b-spinner>
    </div>
    <div v-else-if="errorMessage" class="alert alert-warning" role="alert">
      {{ errorMessage }}
    </div>
    <template v-else-if="client && statData">
      <p v-if="statusHint" class="text-muted mb-4">{{ statusHint }}</p>
      <div class="row justify-content-center">
        <div class="col-lg-6">
          <div class="row">
            <div v-for="stat of statData" :key="stat.title" class="col-12">
              <Stat :title="stat.title" :value="stat.value" />
            </div>
          </div>
        </div>
      </div>
    </template>
  </Layout>
</template>
